import type { ShareTonightPayload } from '~/api/types'
import { money } from '~/calendar/ListView'

import { Frame, Wordmark, link } from './Frame'
import { Line, Stop, meta } from './Line'
import { longNight } from './night'
import s from './Share.module.css'

export type TonightProps = Omit<ShareTonightPayload, 'kind'>

/**
 * Format E: tonight's three, as a story.
 *
 * The three the front page leads with, on one acid line, in time order from the top — the
 * order the front page's own query returns them in. No pictures: the pill at the foot is
 * the calendar opened on the night, and a link sticker goes over it by hand. Nothing here
 * is anybody's: no faces, no marks.
 */
export function Tonight({ host, frame, night, rows }: TonightProps) {
  return (
    <Frame format="E" frame={frame} className={s.tonight}>
      <div className={s.head}>
        <div>
          <span className={`${s.kick} ${s.mono}`} data-probe="data">
            {longNight(night)}
          </span>
          <div className={`${s.big} ${s.disp}`} data-probe="display">
            Tonight
          </div>
        </div>
        <Wordmark />
      </div>
      <Line hue="acid">
        {rows.map(row => (
          <Stop key={row.id}>
            <div className={s.title}>{row.title}</div>
            <span className={`${s.meta} ${s.mono}`}>{meta(row, money(row))}</span>
          </Stop>
        ))}
      </Line>
      <div className={s.foot}>
        <span className={`${s.link} ${s.mono}`}>{link(host, `/calendar?on=${night}`)}</span>
      </div>
    </Frame>
  )
}
